// ABOUTME: Pure helpers for AnalyticsTimeChart's compact-mode X-axis domain (issue #1900).

/**
 * Returns the X-axis domain for the compact timeline card: 6am-10pm by default,
 * widened only far enough to include any event hour outside that window.
 */
export function computeCompactXDomain(eventHours: number[]): [number, number] {
  return [Math.min(6, ...eventHours), Math.max(22, ...eventHours)];
}
